export type RatesTabMessages = {
  ratesTabTitle: string;
  ratesTitle: string;
  ratesText3: string;
  ratesText5: string;
  ratesText6: string;
  ratesText10: string;
  ratesText11: string;
  ratesText13: string;
  ratesText14: string;
  ratesText16: string;
  ratesText17: string;
  ratesText19: string;
  ratesText20: string;
  primaryTextBankSlip: string;
  primaryTextCreditOneInstallment: string;
  primaryTextCreditUpToSix: string;
  primaryTextCreditUpToTwelve: string;
  primaryTextDebit: string;
  primaryTextPixDynamic: string;
  primaryTextPixStatic: string;
  accountNotApprovedMessage: string;
  accountNotApprovedDescription: string;
};

export const ratesTabMessages: RatesTabMessages = {
  ratesTabTitle: "Taxas",
  ratesTitle: "Taxas",
  ratesText3: "Boleto Bancário",
  ratesText5: "Recebimento em 1 dia útil após o pagamento.",
  ratesText6: "Cartão de Crédito",
  ratesText10: "Recebimento em 32 dias após o pagamento.",
  ratesText11: "Cartão de Débito",
  ratesText13: "Recebimento em 3 dias após o pagamento.",
  ratesText14: "Pix Dinâmico",
  ratesText16: "Receba em poucos segundos após o pagamento.",
  ratesText17: "Pix",
  ratesText19: "(Chave, manual ou QR Code estático)",
  ratesText20: "Receba em poucos segundos após o pagamento.",

  // Textos primários que aparecem nas listas
  primaryTextBankSlip: "por boleto pago",
  primaryTextCreditOneInstallment: "à vista",
  primaryTextCreditUpToSix: "de 2 a 6 parcelas",
  primaryTextCreditUpToTwelve: "de 7 a 12 parcelas",
  primaryTextDebit: "",
  primaryTextPixDynamic: "por cobrança recebida",
  primaryTextPixStatic: "por cobrança recebida",
  accountNotApprovedMessage: "Conta não aprovada",
  accountNotApprovedDescription:
    "As tarifas estarão disponíveis após a aprovação da conta Talk2Pay.",
};
